import { QueryClient } from 'react-query';
import { ITemplate } from 'entities/template/template';

export const invalidateTemplateQueries = (queryClient: QueryClient, template: ITemplate, queryKey: string) => {
  queryClient.invalidateQueries(queryKey);
  queryClient.invalidateQueries(['templates', false, template.channel, template.type, template.siteId]);
  queryClient.invalidateQueries(['templates', true, template.channel, template.type, template.siteId]);
};
